import HomePage from '../pages/HomePage';
import SalesStackLogin from '../pages/SalesStackLogin';
import SignInPage from '../pages/SignIn';

export default [
  {
    path: '/',
    component: HomePage,
    exact: true,
  },
  {
    path: '/signin',
    component: SignInPage,
    exact: true,
  },
  {
    path: '/sales-stack/login',
    component: SalesStackLogin,
    exact: true,
  },
  {
    path: '/*',
    component: HomePage,
    exact: true,
  },
];
